/* eslint @okta/okta/no-specific-modules: 0 */
import Handlebars from 'handlebars';
import markdownToHtml from '../markdownToHtml';

Handlebars.registerHelper('markdown', function (mdText) {
  return markdownToHtml(Handlebars, mdText);
});

export default Handlebars;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/courage/src/util/handlebars/helper-markdown.js
// module id = 51
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/util/handlebars/helper-markdown.js